import { Controller } from "@hotwired/stimulus"

// Click handler that toggles `active` on the parent of the clicked element.
// Designed for accordion-style lists where each item has a header you click
// to expand/collapse — same pattern as the inline scripts on the orders pages.
//
// Usage on the wrapper (delegated click):
//   <div data-controller="accordion-toggle"
//        data-action="click->accordion-toggle#toggle"
//        data-accordion-toggle-header-selector-value=".b-profile-order__header">
//     <div class="b-profile-order">
//       <div class="b-profile-order__header">…</div>
//       …body…
//     </div>
//   </div>
export default class extends Controller {
  static values = { headerSelector: String }

  toggle(event) {
    const header = event.target.closest(this.headerSelectorValue)
    if (!header) return
    header.parentElement?.classList.toggle("active")
  }
}
